// ============================================================
// NEWSLETTER - A DÓNDE VA EL CORREO
// ------------------------------------------------------------
// MIENTRAS ESTO ESTÉ VACÍO, EL CORREO NO SE GUARDA EN NINGÚN LADO.
// El formulario muestra el estado de éxito pero la dirección se
// pierde. No lo dejes así si vas a mandar tráfico pago.
//
// Cómo conectarlo en 2 minutos con GoHighLevel:
//   1. GHL -> Automation -> Workflows -> Create Workflow
//   2. Trigger: "Inbound Webhook"
//   3. Copia la URL que te da y pégala abajo
//   4. Acción siguiente: Create/Update Contact con el campo email
//
// Sirve igual cualquier endpoint que acepte un POST con JSON:
// Zapier, Make, Formspree, un webhook de n8n.
//
// El payload que mandamos es:
//   { email, source: 'blinkblis.com', path, lang, ts }
// ============================================================

export const NEWSLETTER_WEBHOOK = ''

export const isNewsletterLive = () => NEWSLETTER_WEBHOOK.trim().length > 0
